

const template = document.createElement('template');

template.innerHTML = `
<style>
  .hidden-view {
      display: none
  }

  .button-bar {
    position: absolute;
    display: flex;
    justify-content: flex-end;
    right: 0;
    z-index: 4;
  }

  @media only screen and (max-width: 63.99em){
    .button-bar {
      right: 1rem;
    }
  }

  .button {
    padding: unset;
    border: unset;
    cursor: pointer;
    color: #fff;
    font-size: .8125rem;
    line-height: 1.1;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    font-family: FF Meta W05,Helvetica,Arial,sans-serif;
    font-weight: 600;
    text-align: center;
    outline: none!important;
    width: 45px;
    height: 45px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
  }

  .button > img {
    display: none;
  }

  .button--3d {
    background-image: url("\/\/cdn.shopify.com\/s\/files\/1\/0561\/7333\/0515\/files\/3D_Icon_f041b778-55b2-42e4-9060-68a9571fa7ab.svg?v=1754921424")
  }

  .button--3d:hover {
    background-image: url("\/\/cdn.shopify.com\/s\/files\/1\/0561\/7333\/0515\/files\/3D_Hover.svg?v=1754921424")
  }

  .button--2d {
    background-image: url("\/\/cdn.shopify.com\/s\/files\/1\/0561\/7333\/0515\/files\/2D_Icon_b8814e9a-9ee3-4eca-95ce-6bd9b48fc6b3.svg?v=1754921424")
  }
</style>
<slot name="title"></slot>
<div class="button-bar">
  <button class="button button--3d" type="button" title="View 3d Model"></button>
</div>
<div class="viewer-2d">
  <slot name="viewer2d"></slot>
</div>
<div class="viewer-3d hidden-view">
  <slot name="viewer3d"></slot>
</div>
`;

class TDCViewerSwitch extends HTMLElement { switchButton; switchButtonHandler; slotChangeHandler; skuChangeWatcher;
currentVariant;

viewer2d; viewer3d; viewer2dSlot;

productNameNode;

constructor() { super(); this.attachShadow({mode: 'open'}); this.shadowRoot.append(template.content.cloneNode(true));

this.switchButtonHandler = () => this.switchView(); this.switchHoverHandler = (e) => this.switchHover(e);

this.switchButton = this.shadowRoot.querySelector('.button-bar > button'); this.switchButton.addEventListener('click',
this.switchButtonHandler);

this.viewer1 = this.shadowRoot.querySelector('.viewer-2d'); this.viewer2 = this.shadowRoot.querySelector('.viewer-3d');
this.viewer2dSlot = this.shadowRoot.querySelector('slot[name="viewer2d"]');

this.slotChangeHandler = () => {

const assigned2dNodes = this.viewer2dSlot.assignedNodes(); if (assigned2dNodes.length > 0) { const productNameNode =
assigned2dNodes[0].querySelector('.product-name-mobile'); productNameNode.style.display = 'none';

const clonedNameNode = productNameNode.cloneNode(true);

clonedNameNode.style.display = ''; clonedNameNode.slot = 'title';

this.productNameNode ? this.productNameNode.replaceWith(clonedNameNode) : this.append(clonedNameNode);

}

};

this.viewer2dSlot.addEventListener('slotchange', this.slotChangeHandler); }

switchView() { this.viewer1.classList.toggle('hidden-view'); this.viewer2.classList.toggle('hidden-view');
this.switchButton.classList.toggle('button--3d'); this.switchButton.classList.toggle('button--2d'); }

updateSkuIfNeeded() { const variant = (new URL(location.href)).searchParams.get('variant'); this.tdcKonfigurator =
this.querySelector('tdc-kongfigurator');

if (variant !== this.currentVariant) { this.currentVariant = variant;

this.tdcKonfigurator.sku = meta.product.variants .find(({id}) => `${id}` === variant) .sku.replace(/\s/g, ''); } }

connectedCallback() { this.skuChangeWatcher = setInterval(() => this.updateSkuIfNeeded(), 500); }

disconnectedCallback() { this.switchButton.removeEventListener('click', this.switchButtonHandler);
clearInterval(this.skuChangeWatcher); this.viewer2dSlot.removeEventListener('slotchange', this.slotChangeHandler); } }

customElements.define('tdc-viewer-switch', TDCViewerSwitch);
